import { render } from "./VolunteersPage.vue?vue&type=template&id=1e147b54"
import script from "./VolunteersPage.vue?vue&type=script&lang=js"
export * from "./VolunteersPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__